export default {
  datumZverejneniaOd: null,
  datumZverejneniaDo: null,
  datumUcinnostiOd: null,
  datumUcinnostiDo: null,
  searchTextVyraz: '',
  searchTextCislo: '',
  searchTextNazov: '',
  searchTextRocnik: '',
  rezort: null,
};
